"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.dashboard.selectGroupHint': 'Selecciona un grupo para ver los mensajes',
    'whatsapp.dashboard.statsStatus': 'Estado de grupos',
};
